import React from 'react';
import { StyledNoResults } from './NoResults.styles';
export function NoResults({ clearFilters, hasFiltersApplied, message }) {
    return (React.createElement(StyledNoResults, null,
        React.createElement("p", null, message),
        hasFiltersApplied && (React.createElement("p", null,
            React.createElement("span", { onClick: clearFilters }, "Click here"),
            " to reset the filters."))));
}
//# sourceMappingURL=NoResults.js.map